import { EProductPriority, ESaleDiscountDisplayType } from 'constants/enums';

export const SALE_DISCOUNT_TYPE_OPTIONS = [
    { value: ESaleDiscountDisplayType.PERCENTAGE, label: 'Percentage' },
    { value: ESaleDiscountDisplayType.MULTIPLIER, label: 'Multiplier' },
    { value: ESaleDiscountDisplayType.FIXED_AMOUNT, label: 'Fixed amount' }
];

export const PRODUCT_PRIORITY_OPTIONS = Object.values(EProductPriority).map((priority) => ({
    value: priority,
    label: priority
}));

export const SCHEDULE_FIELD_NAME = 'schedule';

